TestTagDirective = () ->
	link: (scope, element, attributes) ->
		name = null

		if attributes.name?
			name = attributes
				.name
				.replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
				.replace(/([a-z\d])([A-Z])/g, '$1_$2')
		else if attributes.id?
			name = attributes.id

		if name != null
			formattedName = name
				.replaceAll(/[^\w]/g, '-')
				.replace(/ctrl-\w{4}/, '')
				.replaceAll('_', '-')
				.replaceAll(/-{2,}/g, '-')
				.replace(/(?:^-|-$)/, '')
				.toLowerCase();
			element.closest('label,div').addClass("tests--#{formattedName}")

angular
	.module 'App.Directive'
	.directive 'input', TestTagDirective
	.directive 'textarea', TestTagDirective
	.directive 'select', TestTagDirective
